import styled from 'styled-components';

const RequestFooter = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Inter UI';
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  justify-content: center;
  line-height: 32px;
  max-width: 512px;
  text-align: center;
  width: 100%;
`;

export default RequestFooter;
